import { PUR2020_R01Dto } from "./Dto_PUR2020_R01";
import { deleteData, getData, postData, putData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { PUR2020_R01Filter } from "./Store_PUR2020_R01";
import { formatDate } from "src/utils/string/stringUtil";

const baseUrl = `${config.apiUrl}/PUR2020_R01`;

const getParams = (filter: Partial<PUR2020_R01Filter>, listLength?: number) => {
    return {
        compCd: filter.compCd,
        startDate: filter.transportDt?.from ? formatDate(filter.transportDt.from) : undefined,
        endDate: filter.transportDt?.to ? formatDate(filter.transportDt.to) : undefined,
        logicCenter: filter.logicCenter,
        itemCd: filter.itemCd,
        brandCd: filter.brandCd,
        customCd: filter.customCd,
        itemGroup: filter.itemGroup,
        inoutClass: filter.inoutClass,
        workplaceCd: filter.workplaceCd,
        listLength: listLength || 0
    }
}

// 리스트 조회
export const getPUR2020_R01List = async (option: string, params: Partial<PUR2020_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`;
    return await getData<ResponseDto<PUR2020_R01Dto[]>>(url, { params: getParams(params, listLength) });
}

export const getPUR2020_R01AllCount = async (params: Partial<PUR2020_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, { params: getParams(params, 0) });
}


// 엑셀 다운로드
export const exportPUR2020_R01Excel = async (option: string, params: Partial<PUR2020_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/excel/${option}`;

    const requestParams = {
        compCd: params?.compCd,
        startDate: params?.transportDt?.from ? formatDate(params.transportDt.from) : undefined,
        endDate: params?.transportDt?.to ? formatDate(params.transportDt.to) : undefined,
        inoutClass: params?.inoutClass,
        logicCenter: params?.logicCenter,
        itemCd: params?.itemCd,
        brandCd: params?.brandCd,
        itemGroup: params?.itemGroup,
        customCd: params?.customCd,
        workplaceCd: params?.workplaceCd,
    }
    return await getData<ResponseDto<string>>(url, { params: { ...requestParams, listLength } });
}


